import styled, { css } from 'styled-components';

export const HeaderWrapper = styled.ul`
  width: 100%;
  max-width: 120rem;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.2rem;

  margin-bottom: 2rem;
  padding: 1rem;

  span {
    font-weight: 700;
    margin-right: 1rem;
  }
`;

export const Columns = styled.div`
  ${({ grid }) => css`
    display: grid;
    grid-template-columns: repeat(${grid}, 1fr);
    gap: 1.5rem;
  `}
`;
